import React, { useState } from 'react'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Form from 'antd/lib/form'
import { validatePassword, comparePasswords } from './helpers'
import { Auth } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { setErrorMessage, setShowNewPassword } from '../../redux/auth/actions'

const { Item } = Form

const styles = {
    submitButton: {
        marginTop: '1em',
        width: 160,
        borderRadius: 7
    },
    submitContainer: {
        textAlign: 'center',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

const NewPassword = ({ onStateChange }) => {
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    console.log("new")
    const errorMessage = useSelector((state) => state.auth.errorMessage)
    const user = useSelector((state) => state.auth.user)

    const completeNewPassword = () => {
        if (comparePasswords(password, confirmPassword) && validatePassword(password)) {
            Auth.completeNewPassword(
                user, // the Cognito User Object
                password // the new password
            ).then((user) => {
                    onStateChange('signedIn', {})
                    setShowNewPassword(false)
                    setErrorMessage('')
                }).catch((e) => {
                    console.log(e)
                })
        } else {
            setErrorMessage(
                'Passwords must be at least 8 characters and include at least one number.'
            )
        }
    }

    const checkKeyPress = (e) => {
        const { key, keyCode } = e;
        if (keyCode === 13) {
            completeNewPassword()
        }
    }

    return (
        <>
            <div style={styles.error}>{errorMessage}</div>
            <div style={{ marginTop: '0.64em' }}>
                <div style={{ marginTop: '1em' }}>
                    <span>New Password:</span>
                    <Input
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        value={password}
                    />
                </div>
                <div style={{ marginTop: '0.32em' }}>
                    <Input
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type="password"
                        value={confirmPassword}
                        placeholder='Confirm New Password...'
                        onKeyDown={checkKeyPress}
                    />
                </div>
                <div style={styles.submitContainer}>
                    <Button
                        htmlType="submit"
                        onClick={completeNewPassword}
                        size="large"
                        style={styles.submitButton}
                        type="primary"
                    >
                        Change Password
                    </Button>
                </div>
            </div>
        </>
    )
}

export default NewPassword
